import axios from 'axios';
import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const getYoutubeVideo = () => {
    const url = `${URL_BASE_API}/api/util/getyoutubevideo`;
    const language = store.getState().configuration.language;

    const rsp = fetchDataAPI(
        url,
        {
            lang: language
        }
    );
    
    return rsp;
}


export const getGoogleClientId = () => {
    const url = `${URL_BASE_API}/api/util/getgoogleclientid`;
    const language = store.getState().configuration.language;

    const rsp = fetchDataAPI(
        url,
        {
            lang: language
        }
    );
    
    return rsp;
}
